const PrincipalDesk = () => {
    return (
        <div id="principal" className="about-message container">
            <div className="message-left">
                <img src="https://picsum.photos/300/350" alt="director" />
            </div>

            <div className="message-right">
                <h2>Principal's Desk</h2>
                <p>
                    Dear Students and Parents,
                </p><br />
                <p>
                    It is a privilege to welcome you to the Nav Jeevan Mission School website. 
                    For a school that has a history of tradition and a heritage that we are extremely 
                    proud of, it is no mean task to place on the World Wide Web information that encompasses 
                    and indeed enshrines that something special that Nav Jeevan stands for. Within these pages 
                    we hope you can catch a glimpse of what the school seeks to achieve and indeed, more 
                    importantly, means to each one of the Navjeevan family. I use the word glimpse deliberately 
                    because despite our best efforts it is not possible to capture all facets of the school and 
                    give them adequate coverage either in text or in pictures. Hopefully, what our website will 
                    achieve will be a means to let our alumni, parents and well-wishers keep abreast with what 
                    is happening at school and perhaps freshen fond memories of yesteryear. It will be our effort 
                    to update the site regularly with pictures and reports on the events as they happen and hope 
                    that we can make your visit to the site more relevant and meaningful. We hope that the website 
                    proves to be a worthwhile microcosm of the school and was worth the visit for you. Thank you for 
                    the visit and former students, please do enter your details in the Guest Book
                </p>
                <h4>MR.BARTHALOM KATA</h4>
                <h4>- Principal -</h4>
            </div>

        </div>
    );
};

export default PrincipalDesk;